import React, { useContext, useEffect, useRef, useState } from 'react';
import { Icon, Row } from 'antd';

import { ContentListGlobalAI } from '../contentList/contentListGlobal/ContentListGlobalAI';
import {
  ChatSpan,
  ChatSpanRight,
  ColIA,
  ColResult,
  HeaderResults,
  HrResult,
  IAChatContainer,
  IconMessage,
  IconMessageRight,
  MessageContainer,
  MessageContainerRight
} from './styles';
import { getAISearch } from '../contentList/contentListGlobal/services/getAISearch';
import { GlobalFiltersContext } from '../home/GlobalFiltersContext';
import arrowIcon from '../../../assets/images/arrow-icon-gray.png';
import { NavbarSearchIA } from '../../../components/_shell/NavbarSearch/NavbarSearchIA';
import { IAInitialPage } from './IAInitialPage';

export const IAChat = () => {
  const DEFAULT_AI_MESSAGE = 'Desculpe, não consegui compreender sua mensagem.';

  const [lastPrompt, setLastPrompt] = useState<string>('');

  const messagesEndRef = useRef(null);

  const scrollToBottom = () => {
    if (messagesEndRef.current) {
      messagesEndRef.current.scrollTop = messagesEndRef.current.scrollHeight;
    }
  };

  const {
    totalGlobal,
    aiSearchText,
    loadingAI,
    setLoadingAI,
    aiChat,
    setAIChat,
    submitAI,
    lastAIResult,
    setLastAIResult,
    setAiSearchText
  } = useContext(GlobalFiltersContext);

  useEffect(() => {
    scrollToBottom();
  }, [aiChat]);

  useEffect(() => {
    if (submitAI) {
      fetchSearchAI();
    }
  }, [submitAI]);

  useEffect(() => {
    if (Object.keys(lastAIResult).length === 0) return;
    const newAiChatResponse = JSON.parse(JSON.stringify(aiChat));
    const iaText = lastAIResult.message || DEFAULT_AI_MESSAGE;
    newAiChatResponse.push({
      type: 'ai',
      message: iaText
    });

    setAIChat(newAiChatResponse);
  }, [lastAIResult]);

  const fetchSearchAI = async () => {
    if (!aiSearchText) return;
    setLastPrompt(aiSearchText);
    setLoadingAI(true);
    const newAiChat = JSON.parse(JSON.stringify(aiChat));
    newAiChat.push({
      type: 'user',
      message: aiSearchText
    });
    setAIChat(newAiChat);

    const data: { message: string; conversation_id?: string } = {
      message: `${aiSearchText}`
    };

    if (lastAIResult && lastAIResult.conversation_id) {
      data.conversation_id = lastAIResult.conversation_id;
    }

    setAiSearchText('');
    try {
      const response = await getAISearch(data);
      if (response.data) {
        const d = response.data;
        if (d.data && String(d.data).toLowerCase() === 'not found') {
          const message = d.message ? d.message : DEFAULT_AI_MESSAGE;
          const updatedChatWithError = [...newAiChat, { type: 'ai', message }];
          setAIChat(updatedChatWithError);
          setLastAIResult({});
        } else {
          setLastAIResult(d);
        }
      } else {
        const message = DEFAULT_AI_MESSAGE;
        const updatedChatWithError = [...newAiChat, { type: 'ai', message }];
        setAIChat(updatedChatWithError);
        setLastAIResult({});
      }
    } catch (error) {
      console.error('Error fetching AI search:', error);
      const message = 'Ocorreu um erro ao buscar a resposta. Tente novamente.';
      const updatedChatWithError = [...newAiChat, { type: 'ai', message }];
      setAIChat(updatedChatWithError);
      setLastAIResult({});
    } finally {
      setLoadingAI(false);
    }
  };

  const breakPoint = 992;

  return (
    <Row gutter={[0, 16]}>
      {' '}
      <ColIA xs={24} sm={24} md={24} lg={12}>
        <HeaderResults>
          <strong>CHAT FÓRUM</strong>
        </HeaderResults>
        <HrResult className="chat-hr" />
        <IAChatContainer ref={messagesEndRef}>
          {aiChat.length > 0 ? (
            <>
              {aiChat.map((c: any, i: number) => {
                if (c.type === 'user') {
                  return (
                    <div
                      key={`chat-user-${i}`}
                      style={{ marginBottom: '15px', clear: 'both' }}>
                      <ChatSpanRight>VOCÊ</ChatSpanRight>
                      <div style={{ clear: 'both', position: 'relative' }}>
                        {' '}
                        <IconMessageRight src={arrowIcon} />
                        <MessageContainerRight>
                          <span>{c.message}</span>
                        </MessageContainerRight>
                      </div>
                    </div>
                  );
                }
                if (c.type === 'ai') {
                  return (
                    <div
                      key={`chat-ai-${i}`}
                      style={{ marginBottom: '15px', clear: 'both' }}>
                      <ChatSpan>CHAT</ChatSpan>
                      <div style={{ clear: 'both', position: 'relative' }}>
                        {' '}
                        <IconMessage src={arrowIcon} />
                        <MessageContainer>
                          <span
                            dangerouslySetInnerHTML={{ __html: c.message }}
                          />
                        </MessageContainer>
                      </div>
                    </div>
                  );
                }
                return null;
              })}
              {loadingAI && (
                <div style={{ textAlign: 'center', padding: '20px' }}>
                  <Icon type="loading" style={{ fontSize: 24 }} />
                </div>
              )}
            </>
          ) : (
            <IAInitialPage />
          )}
        </IAChatContainer>
        <NavbarSearchIA helpLabel={!aiChat.length} />
      </ColIA>
      <ColResult xs={24} sm={24} md={24} lg={12}>
        <HeaderResults>
          <strong>
            {aiChat.length && totalGlobal
              ? `${totalGlobal} itens encontrados`
              : 'Resultados Encontrados'}
          </strong>
        </HeaderResults>
        <HrResult className="results-hr" />
        <ContentListGlobalAI
          isAIChat={true}
          aiChatFilters={lastAIResult}
          searchAIPrompt={lastPrompt}
        />
      </ColResult>
    </Row>
  );
};
